export const DICTIONARY_EN = {
  schedule: {
    day: 'DAY',
    week: 'WEEK',
    workWeek: 'WORKWEEK',
    month: 'MONTH',
    agenda: 'AGENDA',
    weekAgenda: 'Weekly agenda',
    workWeekAgenda: 'Weekly work agenda',
    monthAgenda: 'Monthly agenda',
    today: 'Today',
    noEvents: 'There are no events',
    allDay: 'All day',
    start: 'Start',
    end: 'End',
    more: 'More',
    close: 'Close',
    cancel: 'Cancel',
    noTitle: 'No title',
    delete: 'Delete',
    deleteEvent: 'Delete event',
    selectedItems: 'Selected items',
    deleteSeries: 'Delete series',
    edit: 'Edit',
    editSeries: 'Edit series',
    editEvent: 'Edit event',
    createEvent: 'Create',
    subject: 'Subject',
    addTitle: 'Add title',
    moreDetails: 'More details',
    save: 'Save',
    editContent: 'Would you like to edit only this event or the whole series?',
    deleteRecurrenceContent: 'Would you like to delete this event or the whole series?',
    deleteContent: 'Are you sure you want to delete this event?',
    newEvent: 'New event',
    title: 'Title',
    location: 'Location',
    description: 'Description',
    timezone: 'Time zone',
    startTimezone: 'Start time',
    endTimezone: 'End time',
    repeat: 'Repeat',
    saveButton: 'Save',
    cancelButton: 'Cancel',
    deleteButton: 'Delete',
    recurrence: 'Recurrence',
    editRecurrence: 'Edit recurrence',
    repeats: 'Repeat',
    alert: 'Alerts',
    groups: 'Workers',
    startEndError: 'The selected end date occurs before the start date.',
    invalidDateError: 'The selected date value is invalid.',
    ok: 'Agreed',
  },
  recurrenceeditor: {
    none: 'None',
    daily: 'Dialy',
    weekly: 'Weekly',
    monthly: 'Monthly',
    month: 'Month',
    yearly: 'Yearly',
    never: 'Never',
    until: 'Until',
    count: 'Count',
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
    last: 'Last',
    repeat: 'Repeat',
    repeatEvery: 'Repeat every',
    on: 'Repaet on',
    end: 'End',
    onDay: 'Day',
    days: 'days)',
    weeks: 'weeks)',
    months: 'months)',
    years: 'years)',
    every: 'every',
    summaryTimes: 'times)',
    summaryOn: 'on',
    summaryUntil: 'Until',
    summaryRepeat: 'Repeats',
    summaryDay: 'days)',
    summaryWeek: 'weeks)*',
    summaryMonth: 'months)',
    summaryYear: 'years)',
  },
  calendar: {
    today: 'Today',
  },
  datepicker: {
    today: 'Today',
  },
  grid: {
    EmptyRecord: 'There are nop results',
    True: 'True',
    ShowRowsWhere: 'Show lines where: ',
    Add: 'Add',
    Edit: 'Edit',
    Cancel: 'Cancel',
    Update: 'Update',
    Delete: 'Delete',
  },
  pager: {
    currentPageInfo: '*{0} of {1} pages',
    totalItemsInfo: '*({0} records)*',
    firstPageTooltip: 'Go to first page',
    lastPageTooltip: 'Go to last page',
    nextPageTooltip: 'next page',
    previousPageTooltip: 'prevoius page',
    nextPagerTooltip: '*Go to next pager*',
    previousPagerTooltip: '*Go to previous pager*',
    pagerDropDown: 'Records per page',
    pagerAllDropDown: 'Records',
    All: 'All',
  },
  dropdowns: {
    noRecordsTemplate: '*No records',
    actionFailureTemplate: 'Error on model',
    overflowCountTemplate: '+${count} more...',
    totalCountTemplate: '*${count} selected*',
  },
  daterangepicker: {
    startLabel: 'Start date*',
    endLabel: 'End date',
    applyText: 'Apply',
    cancelText: 'Cancel',
    selectedDays: 'Selected days',
    days: 'Days',
  },
};
